export default {
	"activate.GetTheVerificationCode": "Get the verification code",
	"activate.Resend": "Resend",
	"activate.PleaseEnterYourPhoneNumber": "Please enter your phone number",
	"activate.PleaseEnterTheCorrectMobilePhoneNumber": "Please enter the correct mobile phone number",
	"activate.please": "please",
	"activate.sResendAfterThat": "s resend after that",
	"activate.FailedToGetVerificationCode": "Failed to get verification code",
	"activate.TheVerificationCodeIsNotLegitimate": "The verification code is not legitimate",
	"activate.TheVerificationCodeIsIncorrect": "The verification code is incorrect",
	"activate.ThePhoneNumberThatReceivesTheActivationCode": "The phone number that receives the activation code",
	"activate.VerificationCode": "Verification code",
	"activate.EnquireNow": "Enquire now",
	"activate.TheActivationCodeIsAProductRedemptionVoucherObtainedFromAThirdPartyAndCanBeRedeemedForTheCorrespondingProduct": "The activation code is a product redemption voucher obtained from a third party and can be redeemed for the corresponding product"
}